/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Misa_Template_HelpInputs */

const vi_invoice_misa_template_help = /** @type {(inputs: Invoice_Misa_Template_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn mẫu dùng để lập hóa đơn điện tử gửi MISA. Kế toán kiểm tra và ký phát hành trên MISA.`)
};

/**

* @param {Invoice_Misa_Template_HelpInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_help = /** @type {((inputs?: Invoice_Misa_Template_HelpInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_HelpInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_help(inputs)
});